import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import {  useNavigate } from 'react-router-dom';

const RegistrationForm = () => {

  const [validated, setValidated] = useState(false);
  const [fname, setName] = useState("");
  const [lname, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [registrationMessage, setRegistrationMessage] = useState(""); 

  const navigate = useNavigate(); 

  const data = {
    fname,
    lname,
    Email,
    password
  };


  const handleSubmit = (e) => {
    e.preventDefault();


    if (e.currentTarget.checkValidity() === false) {
      setValidated(true);
      return;
    }

    axios
      .post("http://localhost:8000/postdata", data)
      .then((response) => {
        console.log(data);
        setRegistrationMessage("Registration successful! You can now login with your credentials.");
        setValidated(false); 
    
        setTimeout(() => {
          navigate("/");
        }, 2000); 
      })
      .catch((err) => {
        console.log(err);
        setRegistrationMessage("Something went wrong. Please try again.");
      });
  };

  return (
    <Container className="">
      <h3 className="text-center mb-4 " style={{color:'#093c60'}}>"Get in Touch – We’re Here to Help!"</h3>
      <Row className="justify-content-center">
        <Col md={6} sm={12} className='mb-5 '>
          <div className="card shadow-lg p-4">
            <h3 className='text-center '>Connect with Our Team</h3>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group controlId="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your first name"
                  name="firstName"
                  value={fname}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="mb-3"
                />
                <Form.Control.Feedback type="invalid">
                  First name is required.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your last name"
                  name="lastName"
                  value={lname}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  className="mb-3"
                />
                <Form.Control.Feedback type="invalid">
                  Last name is required.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  name="email"
                  value={Email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mb-3"
                />
                <Form.Control.Feedback type="invalid">
                  A valid email is required.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mb-3"
                />
                <Form.Control.Feedback type="invalid">
                  Password is required.
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex justify-content-center mt-4">
                <Button type="submit" variant="" className="w-25 text-white" style={{backgroundColor:'#093c60'}} >
                  Submit
                </Button>
              </div>
            </Form>
            {registrationMessage && (
              <div className="mt-3 text-center">
                <p className="text-success">{registrationMessage}</p>
              </div>
            )}

        
          </div>
        </Col>
        <Col md={6} sm={12} className='mb-5'>

          <iframe
            title="location-map"
            frameBorder="0"
            style={{ border: 0, width: '100%', height: '100%', borderRadius: '8px' }}
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d77054.31409843857!2d73.74275349857025!3d19.988116424324804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1737626046129!5m2!1sen!2sin"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </Col>


      </Row>
    </Container>
  );
};

export default RegistrationForm;
